import {Action} from '../../../../../common/types/common';
import {ValidationIdDTO} from '../../../common/types/epics';

export const GOT_VALIDATION_ID_DATA_STEP_STATE_ACTION: Action = {
    name: 'GOT_VALIDATION_ID_DATA_STEP_STATE_ACTION',
    action: (validationId: ValidationIdDTO) => ({
        validationId,
        type: GOT_VALIDATION_ID_DATA_STEP_STATE_ACTION.name
    })
};

export const GET_VALIDATION_ID_EXTRACTED_DATA_ACTION: Action = {
    name: 'GET_VALIDATION_ID_EXTRACTED_DATA_ACTION',
    action: (token: string) => ({
        token,
        type: GET_VALIDATION_ID_EXTRACTED_DATA_ACTION.name
    })
};

export const GOT_VALIDATION_ID_EXTRACTED_DATA_ACTION: Action = {
    name: 'GOT_VALIDATION_ID_EXTRACTED_DATA_ACTION',
    action: (extractedData: any) => ({
        extractedData,
        type: GOT_VALIDATION_ID_EXTRACTED_DATA_ACTION.name
    })
};

export const DO_VALIDATE_ID_ACTION: Action = {
    name: 'DO_VALIDATE_ID_ACTION',
    action: () => ({
        type: DO_VALIDATE_ID_ACTION.name
    })
};

export const CHECK_VALIDATE_ID_RESPONSE_ACTION: Action = {
    name: 'CHECK_VALIDATE_ID_RESPONSE_ACTION',
    action: () => ({
        type: CHECK_VALIDATE_ID_RESPONSE_ACTION.name
    })
};

export const RESEND_CURP_TO_ID_VALIDATION_ACTION: Action = {
    name: 'RESEND_CURP_TO_ID_VALIDATION_ACTION',
    action: (token, curp) => ({
        token, curp,
        type: RESEND_CURP_TO_ID_VALIDATION_ACTION.name
    })
};

export const RESEND_OTHERS_TO_ID_VALIDATION_ACTION: Action = {
    name: 'RESEND_OTHERS_TO_ID_VALIDATION_ACTION',
    action: (token, curp, ocr, cic, registryYear, issueDate, duplicates, electorKey) => ({
        token, curp, ocr, cic, registryYear, issueDate, duplicates, electorKey,
        type: RESEND_OTHERS_TO_ID_VALIDATION_ACTION.name
    })
};

export const VALIDATION_ID_RESET_ACTION: Action = {
    name: 'VALIDATION_ID_RESET_ACTION',
    action: () => ({
        type: VALIDATION_ID_RESET_ACTION.name
    })
};

export const VALIDATION_ID_RESETED_ACTION: Action = {
    name: 'VALIDATION_ID_RESETED_ACTION',
    action: () => ({
        type: VALIDATION_ID_RESETED_ACTION.name
    })
};
